// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row-spacing[data-v-d0c7a258] {\r\n  margin-bottom: 20px;\n}\r\n", ""]);
// Exports
module.exports = exports;
